import script from "./DropshipMfgIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./DropshipMfgIndicator.vue?vue&type=script&setup=true&lang=js"

import "./DropshipMfgIndicator.vue?vue&type=style&index=0&id=70a45b87&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70a45b87"]])

export default __exports__